export default __webpack_public_path__ + "media/images/features/saga/title_background-61770f257d805b21b82ef745e1f91912.png";